import { render, staticRenderFns } from "./QuerySelector.vue?vue&type=template&id=6241cc8c&scoped=true&"
import script from "./QuerySelector.vue?vue&type=script&lang=js&"
export * from "./QuerySelector.vue?vue&type=script&lang=js&"
import style0 from "./QuerySelector.vue?vue&type=style&index=0&id=6241cc8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6241cc8c",
  null
  
)

export default component.exports